import React from 'react';

export const ThumbsDown = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.663 20.25C13.121 20.25 13.5501 20.0259 13.8118 19.6501L18.0437 13.573C18.8384 12.4318 19.1925 11.0413 19.0406 9.65901L18.7152 6.6976C18.5762 5.4321 17.5827 4.4297 16.3185 4.27931L14.2014 4.02747C12.5848 3.83516 10.9456 4.00186 9.40075 4.51569C8.31942 4.87535 7.45331 5.69609 7.03603 6.75652L5.32742 11.0986C5.24477 11.3086 5.18765 11.5278 5.15729 11.7515C4.89298 13.6986 6.65242 15.3118 8.56938 14.8798L12.3399 14.0302C12.3595 14.0258 12.3717 14.0278 12.3804 14.0305C12.3911 14.0339 12.4035 14.0409 12.4147 14.0525C12.4259 14.064 12.4326 14.0766 12.4356 14.0874C12.4381 14.0963 12.4397 14.1085 12.4347 14.128L11.3074 18.5006C11.079 19.3866 11.7481 20.25 12.663 20.25Z"
        fill="#919EAB"
      />
    </svg>
  );
};
